import { useState, useEffect, useCallback } from "react";

export const usePdfDocument = (src: string) => {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setNumPages(null);
    setPageNumber(1);
    setLoading(true);
    setError(null);
  }, [src]);

  const onDocumentLoadSuccess = useCallback((data: { numPages: number }) => {
    setNumPages(data.numPages);
    setLoading(false);
    setError(null);
  }, []);

  const onDocumentLoadError = useCallback((err: Error) => {
    setError(err.message);
    setLoading(false);
  }, []);

  return {
    numPages,
    pageNumber,
    setPageNumber,
    loading,
    error,
    onDocumentLoadSuccess,
    onDocumentLoadError,
  };
};
